// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZAx3r01pTaZLiGzbd9Ko {
    display: flex;
    position: relative;
    width: 80%;
    padding: 1%;
    height: 5vh;
    border-radius: 10px;
    justify-content: flex-start;
    align-items: center;
}

.wWbnHJqtR_dtjyTANxct {
    flex: 1;
    position: absolute;
    left: 0;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.J2JjiQ8D3nUkYQ_v8CF3 {
    display: flex;
    position: relative;
    transition: margin-left 0.5s ease-in-out;
    width: 48%;
    height: 82%;
    border-radius: 8px;
}

.o3mtZFDf3Bv3v6MuOLIS {
    flex: 1;
    display: flex;
    justify-content: center;
    alignitems: center;
}

.PH_13vZ3uGVdMaoYaeCz {
  flex: 1;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Items.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[".segmentedControlContainer {\n    display: flex;\n    position: relative;\n    width: 80%;\n    padding: 1%;\n    height: 5vh;\n    border-radius: 10px;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.segmentedControlTabsContainer {\n    flex: 1;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.highlightBlock {\n    display: flex;\n    position: relative;\n    transition: margin-left 0.5s ease-in-out;\n    width: 48%;\n    height: 82%;\n    border-radius: 8px;\n}\n\n.segmentedControlItemContainer {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    alignitems: center;\n}\n\n.segmentedControlItem {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export var segmentedControlContainer = `ZAx3r01pTaZLiGzbd9Ko`;
export var segmentedControlTabsContainer = `wWbnHJqtR_dtjyTANxct`;
export var highlightBlock = `J2JjiQ8D3nUkYQ_v8CF3`;
export var segmentedControlItemContainer = `o3mtZFDf3Bv3v6MuOLIS`;
export var segmentedControlItem = `PH_13vZ3uGVdMaoYaeCz`;
export default ___CSS_LOADER_EXPORT___;
